import api from './api';

const d = (r) => r.data;
const MP = { headers: { 'Content-Type': 'multipart/form-data' } };
const B = '/api/rental';
export const rentalAPI = {
  meta: () => api.get(`${B}/meta`).then(d),
  list: (params) => api.get(`${B}/properties`, { params }).then(d),
  dashboard: (params) => api.get(`${B}/dashboard`, { params }).then(d),
  clientProps: (cid) => api.get(`${B}/clients/${cid}/properties`).then(d),
  create: (body) => api.post(`${B}/properties`, body).then(d),
  get: (id) => api.get(`${B}/properties/${id}`).then(d),
  update: (id, body) => api.put(`${B}/properties/${id}`, body).then(d),
  owners: (id, list) => api.put(`${B}/properties/${id}/ownerships`, list).then(d),
  changeRequest: (id, body) => api.post(`${B}/properties/${id}/change-requests`, body).then(d),
  resolveCR: (id) => api.post(`${B}/change-requests/${id}/resolve`).then(d),
  archive: (id) => api.post(`${B}/properties/${id}/archive`).then(d),
  markSold: (id, body) => api.post(`${B}/properties/${id}/mark-sold`, body).then(d),
  putRecord: (id, kind, body) => api.put(`${B}/properties/${id}/records/${kind}`, body).then(d),
  addRecord: (id, kind, body) => api.post(`${B}/properties/${id}/records/${kind}`, body).then(d),
  editRecord: (id, kind, rid, body) => api.put(`${B}/properties/${id}/records/${kind}/${rid}`, body).then(d),
  upload: (id, fd) => api.post(`${B}/properties/${id}/documents`, fd, MP).then(d),
  approveDoc: (did) => api.post(`${B}/documents/${did}/approve`).then(d),
  createYear: (id, fy) => api.post(`${B}/properties/${id}/years`, { financial_year: fy }).then(d),
  year: (fid) => api.get(`${B}/years/${fid}`).then(d),
  patchYear: (fid, body) => api.put(`${B}/years/${fid}`, body).then(d),
  addItem: (fid, body) => api.post(`${B}/years/${fid}/items`, body).then(d),
  editItem: (iid, body) => api.put(`${B}/items/${iid}`, body).then(d),
  deleteItem: (iid) => api.delete(`${B}/items/${iid}`).then(d),
  approveItem: (iid) => api.post(`${B}/items/${iid}/approve`).then(d),
  submit: (fid) => api.post(`${B}/years/${fid}/submit`).then(d),
  unlock: (fid) => api.post(`${B}/years/${fid}/unlock`).then(d),
  request: (id, body) => api.post(`${B}/properties/${id}/requests`, body).then(d),
  requestMissing: (fid) => api.post(`${B}/years/${fid}/request-missing`).then(d),
  respond: (rid, message) => api.post(`${B}/requests/${rid}/respond`, { message }).then(d),
  closeRequest: (rid) => api.post(`${B}/requests/${rid}/close`).then(d),
  taxReturns: (cid) => api.get(`${B}/clients/${cid}/tax-returns`).then(d),
  createTaxReturn: (cid, fy) => api.post(`${B}/clients/${cid}/tax-returns`, { financial_year: fy }).then(d),
  taxReturn: (tid) => api.get(`${B}/tax-returns/${tid}`).then(d),
  refreshTaxReturn: (tid) => api.post(`${B}/tax-returns/${tid}/refresh`).then(d),
  suggestions: (fid) => api.get(`${B}/years/${fid}/suggestions`).then(d),
  acceptSuggestion: (sid, body) => api.post(`${B}/suggestions/${sid}/accept`, body).then(d),
  rejectSuggestion: (sid, reason) => api.post(`${B}/suggestions/${sid}/reject`, { reason }).then(d),
  rerunExtraction: (fid) => api.post(`${B}/years/${fid}/extract`).then(d),
  review: (fid) => api.get(`${B}/years/${fid}/review`).then(d),
  runReview: (fid) => api.post(`${B}/years/${fid}/review`).then(d),
  resolveFinding: (id, action, note) => api.post(`${B}/findings/${id}/resolve`, { action, note }).then(d),
  comparison: (fid) => api.get(`${B}/years/${fid}/comparison`).then(d),
  reviewSettings: (body) => api.put(`${B}/settings/review`, body).then(d),
  propertyGst: (pid, fy) => api.get(`${B}/properties/${pid}/gst`, { params: { financial_year: fy } }).then(d),
  clientGst: (cid, fy) => api.get(`${B}/clients/${cid}/gst`, { params: { financial_year: fy } }).then(d),
  gstSummary: (sid) => api.get(`${B}/gst-summaries/${sid}`).then(d),
  sale: (pid) => api.get(`${B}/properties/${pid}/sale`).then(d),
  saveSale: (pid, body) => api.put(`${B}/properties/${pid}/sale`, body).then(d),
  discountOverride: (pid, body) => api.post(`${B}/properties/${pid}/sale/discount-override`, body).then(d),
  approveSale: (pid) => api.post(`${B}/properties/${pid}/sale/approve`).then(d),
  exports: (tid) => api.get(`${B}/tax-returns/${tid}/exports`).then(d),
  createExport: (tid, format) => api.post(`${B}/tax-returns/${tid}/exports`, { format }).then(d),
  adapters: () => api.get(`${B}/integrations/adapters`).then(d),
  push: (tid, adapter) => api.post(`${B}/tax-returns/${tid}/push/${adapter}`).then(d),
};
export const errText = (e) => {
  const v = e?.response?.data?.detail;
  return typeof v === 'string' ? v : Array.isArray(v) ? v.map((x) => x.msg).join('; ') : e?.message || 'Something went wrong';
};
export const aud = (n) => (n == null ? '—' : Number(n).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' }));
export const FY_TONE = {
  'Not Started': 'bg-slate-100 text-slate-700', 'Awaiting Client': 'bg-amber-100 text-amber-800', 'Documents Received': 'bg-sky-100 text-sky-800',
  'Accountant Review': 'bg-violet-100 text-violet-800', 'Queries Sent': 'bg-orange-100 text-orange-800', 'Ready for Tax Return': 'bg-emerald-100 text-emerald-800',
  Completed: 'bg-emerald-200 text-emerald-900',
};
